/**
 * Steuerstatus zu einem Tag (0062): Kleinunternehmer ja/nein aus dem Verlauf mit Gültig-ab. Belege nehmen den Stand zu
 * ihrem Leistungs- bzw. Rechnungsdatum, nicht den heutigen Schalter. Ohne Verlauf gilt der Schalter (fallback).
 */
export interface TaxStatusEntry {
  small_business: boolean;
  valid_from: string;
}

export function smallBusinessOn(history: readonly TaxStatusEntry[] | null | undefined, date: string | null | undefined, fallback: boolean): boolean {
  if (!history?.length || !date) return fallback;
  const day = date.slice(0, 10);
  let hit: TaxStatusEntry | null = null;
  for (const h of history) if (h.valid_from <= day && (!hit || h.valid_from >= hit.valid_from)) hit = h;
  return hit ? hit.small_business : fallback;
}
